import React, { useState, useEffect } from "react";
import useBrandFilter from "./StatesStore/BrandFilters";
import Skeleton from "./Products/Skeleton";
import ProductCard9 from "./Products/ProductCard9";
import BottomTray from "./Trays/BottomTray";
import FilterTray from "./Trays/FilterTray";
import FilterModal from "./Brands/FilterModal";
import { useParams } from "react-router-dom";
import fetchProducts from "./lib/productUtils";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
} from "firebase/firestore";
import { db } from "./FirebaseConfig";
import { getCategoryDisplayName } from "./lib/getCategoryName";

function AllProducts() {
  const { BrandFilter, setBrandFilter } = useBrandFilter();

  const [allProducts, setAllProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(15);
  const [lastVisible, setLastVisible] = useState(null);
  const [loading, setLoading] = useState(false);
  const [countLeft, setCountLeft] = useState(true);

  const sortOptions = [
    { value: "NF", name: "Newest First" },
    { value: "PL", name: "Price - Low to High" },
    { value: "PH", name: "Price - High to Low" },
    { value: "DL", name: "Discount - Low to High" },
    { value: "DH", name: "Discount - High to Low" },
  ];
  const [subSubCategory, setSubSubCategory] = useState([]);
  const [displaySubCatMap, setDisplaySubCatMap] = useState({});
  const [alphabeticSizes, setAlphabeticSizes] = useState([]);
  const [numericSizes, setNumericSizes] = useState([]);
  const [availableSizes, setAvailableSizes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [filterOption, setFilterOption] = useState("brands");

  //filters
  let { gender } = useParams();
  let { category } = useParams();
  let { subCategory } = useParams();
  let { catLabel: categoryLabel } = "";

  if (typeof subCategory === "undefined") {
    categoryLabel = "All Products";
  } else {
    // Map category names to display names
    const mappedCategory = getCategoryDisplayName(category);
    const mappedSubCategory = getCategoryDisplayName(subCategory);

    categoryLabel = mappedCategory + " - " + mappedSubCategory;
  }
  const [brands, setBrands] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [range, setRange] = useState([0, 90000]); // Initial value set to [0, 90000]
  const [size, setSize] = useState([]);
  const [color, setColor] = useState([]);
  const [sortBy, setSortBy] = useState("NF");

  const [showTray, setShowTray] = useState(false);

  const handleClose = () => {
    setShowTray(false);
    setShowModal(false);
    setRange([BrandFilter.minprice, BrandFilter.maxprice]);
    setSize(BrandFilter.size);
  };
  const handleBrandChange = (brandProp) => {
    if (selectedBrands.includes(brandProp)) {
      setSelectedBrands(selectedBrands.filter((g) => g !== brandProp));
    } else {
      setSelectedBrands([...selectedBrands, brandProp]);
    }
  };
  // Function to handle changes in the slider value
  const handleRangeChange = (newRange) => {
    setRange(newRange);
  };

  // Function to handle changes in the min value input box
  const handleMinInputChange = (value) => {
    const newRange = [value, range[1]];
    setRange(newRange);
  };

  // Function to handle changes in the max value input box
  const handleMaxInputChange = (value) => {
    const newRange = [range[0], value];
    setRange(newRange);
  };

  const handleSizeChange = (sizeProp) => {
    if (size.includes(sizeProp)) {
      setSize(size.filter((g) => g !== sizeProp));
    } else {
      setSize([...size, sizeProp]);
    }
  };

  const filteredProducts = allProducts;

  const resetBrandFilter = () => {
    handleClose();
    setBrandFilter({
      brand: [],
      color: [],
      size: [],
      category: [],
      subCategory: [],
      subSubCategory: [],
      minprice: 0,
      maxprice: 90000,
    });
    setRange([0, 90000]);
    setSize([]);
    setColor([]);
    setSortBy("NF");
  };

  const handleApplyFilter = () => {
    setBrandFilter({
      brand: selectedBrands,
      color: color,
      size: size,
      category: gender,
      subCategory: category,
      subSubCategory: subCategory,
      minprice: range[0],
      maxprice: range[1],
    });
  };

  useEffect(() => {
    function handleResize() {
      setIsSmallScreen(window.innerWidth < 768);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    console.log("Brand Filter", BrandFilter);
    const ensureArray = (value) => (Array.isArray(value) ? value : [value]);
    fetchProducts({
      activeBrands: [],
      brandName: BrandFilter.brand,
      category: ensureArray(gender),
      subCategory: ensureArray(category),
      subSubCategory: ensureArray(subCategory),
      lastVisible,
      currentPage,
      setAllProducts,
      setLoading,
      setLastVisible,
      setCountLeft,
      sortBy,
      sizes: BrandFilter.size,
      colors: BrandFilter.color,
      minprice: BrandFilter.minprice,
      maxprice: BrandFilter.maxprice,
    });
  }, [BrandFilter, sortBy, currentPage]);

  useEffect(() => {
    if (!category || !subCategory || !gender) return;
    const getBrands = async () => {
      try {
        const brandsCollectionRef = collection(db, "brands");
        const brandsQuery = query(brandsCollectionRef, orderBy("name", "asc"));
        const brandsSnapshot = await getDocs(brandsQuery);
        const brandsData = brandsSnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setBrands(brandsData);
      } catch (error) {
        console.error("Error fetching brands:", error);
      } finally {
        setLoading(false);
      }
    };
    const fetchSizes = async () => {
      try {
        const sizesCollectionRef = collection(db, "sizes");
        const sizesSnapshot = await getDocs(sizesCollectionRef);

        let alphabeticSizes = [];
        let numericSizes = [];

        sizesSnapshot.forEach((doc) => {
          const data = doc.data();
          if (doc.id === "type1") {
            alphabeticSizes = data.Alphabetic;
          } else if (doc.id === "type2") {
            numericSizes = data.Numbers;
          }
        });

        setAlphabeticSizes(alphabeticSizes);
        setNumericSizes(numericSizes);
      } catch (error) {
        console.error("Error fetching sizes:", error);
      }
    };
    getBrands();
    fetchSizes();
    setCurrentPage(1);
    setAllProducts([]);
    setLastVisible(null);
  }, [subCategory, category, gender]);
  const BrandFilterOption = (filterOption, text) => {
    return (
      <div
        style={{
          cursor: "pointer",
          height: isSmallScreen ? "28px" : "32px",
          padding: isSmallScreen ? "10px 16px" : "10px 24px",
          gap: "10px",
          borderRadius: isSmallScreen ? "8px" : "8px",
          borderWidth: "1px",
          border: "1px solid #C3C3C3",
        }}
        className="d-flex align-items-center justify-content-center"
        onClick={() => {
          if (isSmallScreen) {
            setShowTray(true);
          } else {
            setShowModal(true);
          }
          setFilterOption(filterOption);
        }}
      >
        <div
          style={{
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "100%",
            letterSpacing: "0%",
            color: "#676A79",
            whiteSpace: "nowrap",
          }}
        >
          {text}
        </div>
      </div>
    );
  };
  return (
    <>
      <div
        className="card bg-transparent border-0"
        style={{ marginTop: isSmallScreen ? "0" : "20px" }}
      >
        {/* Card header START */}

        <div
          className="d-flex d-md-none hiddenScrollbar"
          style={{
            gap: "8px",
            padding: "10px 6px",
            overflowX: "auto",
            whiteSpace: "nowrap",
          }}
        >
          <div
            style={{
              padding: "10px 32px",
              height: "28px",
              gap: "10px",
              borderRadius: "8px",
              borderWidth: "1px",
              border: "1px solid #005FDA",
            }}
            className="d-flex align-items-center justify-content-center"
            onClick={() => {
              setShowTray(true);
              setFilterOption("brands");
            }}
          >
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: "400",
                fontSize: "14px",
                lineHeight: "100%",
                letterSpacing: "0%",
                color: "#005FDA",
              }}
            >
              Filter
            </div>
          </div>
          {BrandFilter.brand.length > 0 &&
            BrandFilterOption("brands", "Brands")}
          {(BrandFilter.minprice !== 0 || BrandFilter.maxprice !== 90000) > 0 &&
            BrandFilterOption("price", "Price")}
          {BrandFilter.size.length > 0 && BrandFilterOption("size", "Size")}
          {BrandFilter.color.length > 0 && BrandFilterOption("color", "Color")}
          {sortBy !== "NF" && BrandFilterOption("sort", "Sort By")}
        </div>
        <div className="d-none d-md-flex flex-lg-row align-items-center justify-content-between stickyHeader bg-white py-2">
          <div className="d-flex align-items-center gap-4">
            <div
              onClick={() => window.history.back()}
              style={{ cursor: "pointer" }}
            >
              <svg
                width="10"
                height="18"
                viewBox="0 0 10 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 17L1 9L9 1"
                  stroke="#667085"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div
              className="text-start text-truncate"
              style={{
                maxWidth: document.body.offsetWidth - 742,
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "20px",
                color: "#000000",
              }}
            >
              {categoryLabel}
            </div>
          </div>
          <div className="d-flex align-items-center gap-3">
            <div
              style={{
                cursor: "pointer",
                height: "32px",
                padding: "0px 24px",
                gap: "10px",
                borderRadius: "8px",
                borderWidth: "1px",
                border: "1px solid #005FDA",
              }}
              className="d-flex align-items-center justify-content-center"
              onClick={() => {
                setShowModal(true);
                setFilterOption("brands");
              }}
            >
              <div
                style={{
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "100%",
                  letterSpacing: "0%",
                  color: "#005FDA",
                  whiteSpace: "nowrap",
                }}
              >
                Filters
              </div>
            </div>
            {BrandFilter.brand.length > 0 &&
              BrandFilterOption("brands", "Brands")}
            {(BrandFilter.minprice !== 0 || BrandFilter.maxprice !== 90000) >
              0 && BrandFilterOption("price", "Price")}
            {BrandFilter.size.length > 0 && BrandFilterOption("size", "Size")}
            {BrandFilter.color.length > 0 &&
              BrandFilterOption("color", "Color")}
            {sortBy !== "NF" && BrandFilterOption("sort", "Sort By")}
          </div>
        </div>

        {/* Card body START */}
        <div className="row mx-0">
          {/* Product item START */}
          {allProducts.map((product, index) => {
            return (
              // <div className="col-6 col-sm-4 col-md-3 col-lg-20 px-0">
              <ProductCard9
                key={index}
                product={product}
                componentName="AllProducts"
              />
              // </div>
            );
          })}
          {/* Product item END */}
        </div>
        {/* Card body END */}

        {/*} Pagination */}
      </div>

      <button
        className={`btn btn-loader mt-2 mx-1 btn-primary-soft w-100 ${
          loading ||
          !countLeft ||
          filteredProducts.length < currentPage * itemsPerPage
            ? "disabled"
            : ""
        }`}
        onClick={
          !countLeft
            ? null
            : () => {
                if (!loading) {
                  setLoading(true);
                  setCurrentPage((prevValue) => prevValue + 1);
                }
              }
        }
      >
        {loading ? (
          <div class="spinner-grow spinner-grow-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        ) : (
          <span className="load-text">
            {filteredProducts.length >= currentPage * itemsPerPage
              ? "Load more"
              : "No more products to show"}
          </span>
        )}
      </button>
      <style jsx>
        {`
          .brandProductsModal .modal-dialog {
            // max-width: 58.5rem;
            max-width: 45rem;
          }
          .selected {
            background-color: rgb(0, 95, 218);
            color: white;
            // color: rgb(0, 95, 218);
            // background-color: rgb(228, 233, 239);
          }
        `}
      </style>
      {isSmallScreen ? (
        <BottomTray isOpen={showTray} setIsOpen={setShowTray} text={"Filter"}>
          <FilterTray
            filterOption={filterOption}
            setFilterOption={setFilterOption}
            availableGenders={[gender]}
            gender={gender}
            category={category}
            subCategory={subCategory}
            subSubCategory={subSubCategory}
            displaySubCatMap={displaySubCatMap}
            range={range}
            size={size}
            alphabeticSizes={alphabeticSizes}
            availableSizes={availableSizes}
            numericSizes={numericSizes}
            sortBy={sortBy}
            sortOptions={sortOptions}
            setSortBy={setSortBy}
            handleGenderChange={() => {}}
            handleCategoryChange={() => {}}
            handleSubCategoryChange={() => {}}
            handleRangeChange={handleRangeChange}
            handleMinInputChange={handleMinInputChange}
            handleMaxInputChange={handleMaxInputChange}
            handleSizeChange={handleSizeChange}
            handleClose={handleClose}
            resetBrandFilter={resetBrandFilter}
            handleApplyFilter={handleApplyFilter}
            handleBrandChange={handleBrandChange}
            brands={brands}
            selectedBrands={selectedBrands}
            type={"AllProducts"}
          />
        </BottomTray>
      ) : (
        <FilterModal
          showModal={showModal}
          filterOption={filterOption}
          setFilterOption={setFilterOption}
          availableGenders={[gender]}
          gender={gender}
          category={category}
          subCategory={subCategory}
          subSubCategory={subSubCategory}
          displaySubCatMap={displaySubCatMap}
          range={range}
          size={size}
          alphabeticSizes={alphabeticSizes}
          availableSizes={availableSizes}
          numericSizes={numericSizes}
          sortBy={sortBy}
          sortOptions={sortOptions}
          setSortBy={setSortBy}
          handleGenderChange={() => {}}
          handleCategoryChange={() => {}}
          handleSubCategoryChange={() => {}}
          handleRangeChange={handleRangeChange}
          handleMinInputChange={handleMinInputChange}
          handleMaxInputChange={handleMaxInputChange}
          handleSizeChange={handleSizeChange}
          handleClose={handleClose}
          resetBrandFilter={resetBrandFilter}
          handleApplyFilter={handleApplyFilter}
          handleBrandChange={handleBrandChange}
          brands={brands}
          selectedBrands={selectedBrands}
          type={"AllProducts"}
        />
      )}
    </>
  );
}

export default AllProducts;
